import Vue from 'vue'

var CORNER_THRESHOLD = 8
var styleInjected = false

function injectStyles() {
  if (styleInjected) return
  styleInjected = true
  var style = document.createElement('style')
  style.setAttribute('data-excel-fill', '')
  style.textContent = [
    '.excel-fill-table td[data-field] { position: relative; }',
    '.excel-fill-table td[data-field]::after {',
    '  content: ""; position: absolute; right: -3px; bottom: -3px;',
    '  width: 7px; height: 7px; background: #409eff; border: 1px solid #fff;',
    '  cursor: crosshair; opacity: 0; z-index: 10; box-sizing: border-box;',
    '  transition: opacity 0.15s; pointer-events: none;',
    '}',
    '.excel-fill-table td[data-field].fill-corner::after,',
    '.excel-fill-table td[data-field].fill-source::after { opacity: 1; }',
    '.excel-fill-table td[data-field].fill-source { border: 2px solid #409eff; }',
    '.excel-fill-table td[data-field].fill-target { background: #e6f7ff; border: 1px solid #409eff; }'
  ].join('\n')
  document.head.appendChild(style)
}

function getTdFromPoint(x, y) {
  var el = document.elementFromPoint(x, y)
  if (!el) return null
  var node = el
  while (node && node.tagName !== 'TD') node = node.parentElement
  return node
}

function getTrFromPoint(x, y) {
  var el = document.elementFromPoint(x, y)
  if (!el) return null
  var node = el
  while (node && node.tagName !== 'TR') node = node.parentElement
  return node
}

function isNearCorner(td, x, y) {
  var rect = td.getBoundingClientRect()
  return x >= rect.right - CORNER_THRESHOLD && x <= rect.right + 4 &&
         y >= rect.bottom - CORNER_THRESHOLD && y <= rect.bottom + 4
}

function findCellByField(tr, field) {
  if (!tr) return null
  var tds = tr.querySelectorAll('td[data-field]')
  for (var i = 0; i < tds.length; i++) {
    if (tds[i].dataset.field === field) return tds[i]
  }
  return null
}

Vue.directive('excel-fill', {
  inserted: function (el, binding) {
    injectStyles()
    el.classList.add('excel-fill-table')

    var fillSource = null
    var fillTargetEnd = null

    function clearCornerHighlight() {
      var prev = el.querySelector('td.fill-corner')
      if (prev) prev.classList.remove('fill-corner')
    }

    function clearFillHighlight() {
      el.querySelectorAll('td.fill-target').forEach(function (td) {
        td.classList.remove('fill-target')
      })
    }

    function updateTargetHighlight() {
      clearFillHighlight()
      if (!fillSource || fillTargetEnd == null) return
      var start = Math.min(fillSource.row, fillTargetEnd)
      var end = Math.max(fillSource.row, fillTargetEnd)
      // 按 data-rowindex 查找目标行（兼容含子行/汇总行的表格，DOM 顺序不可靠）
      var rows = el.querySelectorAll('tbody tr[data-rowindex]')
      rows.forEach(function (tr) {
        if ((tr.dataset.datakey || 'tableData') !== fillSource.dataKey) return
        var idx = parseInt(tr.dataset.rowindex, 10)
        if (idx < start || idx > end || idx === fillSource.row) return
        var td = findCellByField(tr, fillSource.field)
        if (td) td.classList.add('fill-target')
      })
    }

    function onTableMouseMove(e) {
      if (fillSource) return
      clearCornerHighlight()
      var td = getTdFromPoint(e.clientX, e.clientY)
      if (!td || !td.dataset.field) return
      if (!isNearCorner(td, e.clientX, e.clientY)) return
      td.classList.add('fill-corner')
    }

    function onTableMouseDown(e) {
      var td = getTdFromPoint(e.clientX, e.clientY)
      if (!td || !td.dataset.field) return
      if (!isNearCorner(td, e.clientX, e.clientY)) return
      var tr = td.parentElement
      if (!tr || tr.dataset.rowindex == null) return

      e.preventDefault()
      e.stopPropagation()

      fillSource = {
        row: parseInt(tr.dataset.rowindex, 10),
        field: td.dataset.field,
        td: td,
        dataKey: tr.dataset.datakey || 'tableData'
      }
      fillTargetEnd = fillSource.row
      td.classList.add('fill-source')
      td.classList.remove('fill-corner')

      document.addEventListener('mousemove', onDocMouseMove)
      document.addEventListener('mouseup', onDocMouseUp)
      document.body.style.userSelect = 'none'
    }

    function onDocMouseMove(e) {
      if (!fillSource) return
      var tr = getTrFromPoint(e.clientX, e.clientY)
      if (!tr || tr.dataset.rowindex == null) return
      // 仅允许在同一数据源的行之间拖拽填充
      if ((tr.dataset.datakey || 'tableData') !== fillSource.dataKey) return
      var newEnd = parseInt(tr.dataset.rowindex, 10)
      if (newEnd === fillTargetEnd) return
      fillTargetEnd = newEnd
      updateTargetHighlight()
    }

    function onDocMouseUp() {
      if (fillSource && fillTargetEnd != null) {
        var callback = el._excelFillCallback
        if (typeof callback === 'function') {
          callback({
            field: fillSource.field,
            fromRow: fillSource.row,
            toRow: fillTargetEnd,
            dataKey: fillSource.dataKey
          })
        }
      }
      if (fillSource && fillSource.td) {
        fillSource.td.classList.remove('fill-source')
      }
      clearFillHighlight()
      fillSource = null
      fillTargetEnd = null
      document.removeEventListener('mousemove', onDocMouseMove)
      document.removeEventListener('mouseup', onDocMouseUp)
      document.body.style.userSelect = ''
    }

    el._excelFillCallback = binding.value && binding.value.onFill
    el._excelFillCleanup = function () {
      el.removeEventListener('mousemove', onTableMouseMove)
      el.removeEventListener('mousedown', onTableMouseDown)
      document.removeEventListener('mousemove', onDocMouseMove)
      document.removeEventListener('mouseup', onDocMouseUp)
      document.body.style.userSelect = ''
    }

    el.addEventListener('mousemove', onTableMouseMove)
    el.addEventListener('mousedown', onTableMouseDown)
  },

  update: function (el, binding) {
    el._excelFillCallback = binding.value && binding.value.onFill
  },

  unbind: function (el) {
    if (el._excelFillCleanup) el._excelFillCleanup()
  }
})
